import React from 'react';
import { Hero } from './components/Hero';
import { HookAndProblem } from './components/HookAndProblem';
import { Mechanism } from './components/Mechanism';
import { WhatYouGet } from './components/WhatYouGet';
import { WhoIsItFor } from './components/WhoIsItFor';
import { HowItWorks } from './components/HowItWorks';
import { ProofAndFAQ } from './components/ProofAndFAQ';
import { Offer } from './components/Offer';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-cream font-body selection:bg-gold selection:text-white" data-id="element-0">
      <Hero data-id="element-1" />
      <HookAndProblem data-id="element-2" />
      <Mechanism data-id="element-3" />
      <WhatYouGet data-id="element-4" />
      <WhoIsItFor data-id="element-5" />
      <HowItWorks data-id="element-6" />
      <ProofAndFAQ data-id="element-7" />
      <Offer data-id="element-8" />
      <Footer data-id="element-9" />
    </div>;
}